import { Controller } from "stimulus";
import AjaxLoader from "../../entrypoints/src/admin/utilities/ajax-loader";
import ButtonConfirmation from "../../entrypoints/src/admin/components/confirmations";

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.element.dataset.showLoader && AjaxLoader.show();
      ButtonConfirmation.submit(this.element, [...document.querySelectorAll(this.element.dataset.inputsTargets)]);
    });
  }
};